import React, { useEffect, useState } from "react";
import GuestLayout from "../../../layouts/GuestLayout";
import HeroSection from "../../../components/products/HeroSection";
import QuickSmsSection from "../../../components/products/QuickSmsSection";
import BulkSmsSection from "../../../components/products/BulkSmsSection";
import FeaturesSection from "../../../components/products/FeaturesSection";
import ComparisonSection from "../../../components/products/ComparisonSection";
import SubscriptionPackages from "../../../components/landing/SubscriptionPackages";
import { toast } from "react-toastify";
import Loader from "../../../components/utilities/Loader";
import landingPageRequests from "../../../api/Guest/LandingPageRequests";
import { modifyPackagePrices } from "../../../utils/packageUtils";

const Products = () => {
  const [subscriptionPackages, setSubscriptionPackages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchSubscriptionPackages = async () => {
      try {
        setIsLoading(true);
        const response = await landingPageRequests.getSubscriptionPlans();
        // //console.log("Subscription Plans Response:", response?.data?.data);
        if (response.data.status_code === "000") {
          const modifiedPackages = modifyPackagePrices(response.data.data);
          setSubscriptionPackages(modifiedPackages);
          // //console.log("Fetched Packages:", response.data.data);
        } else {
          toast.error(response.data.reason);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to fetch packages");
      } finally {
        setIsLoading(false);
      }
    };
    fetchSubscriptionPackages();
  }, []);

  const handleViewPricingClick = () => {
    // Scroll to the subscription packages section
    const pricingSection = document.getElementById('subscription-packages');
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <GuestLayout>
      <HeroSection />
      <QuickSmsSection onViewPricing={handleViewPricingClick} />
      <BulkSmsSection />
      <FeaturesSection />
      <ComparisonSection />
      
      {/* Subscription Packages Section */}
      <section id="subscription-packages" className="py-1 bg-gray-50">
        <div className="px-4 mx-auto max-w-7xl">
          {/* <div className="text-center mb-12"> */}
            {/* <h2 className="text-4xl font-bold text-gray-900 md:text-5xl">
              Choose Your Perfect Plan
            </h2>
            <p className="mt-4 text-xl text-gray-600">
              Flexible pricing for businesses of all sizes
            </p> */}
          {/* </div> */}
          <SubscriptionPackages packages={subscriptionPackages} />
        </div>
      </section>
    </GuestLayout>
  );
};

export default Products;